// extracted by mini-css-extract-plugin
module.exports = {"column":"column_column__18h9e","margin":"column_margin__wQ0XN","row":"column_row__3UGQ8","dynamic":"column_dynamic__1mMEy","end":"column_end__1Dd-y"};